import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryUsers(
  {
    page, size, direction, sort, grade, phone, userId
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-users`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
      grade,
      phone,
      userId,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryUser(userId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-users/${userId}`,
    method: 'get',
  });
}

export default {};
